$('.video-play-button').click(function() {
  $('.video--text--wrapper').addClass('cv--showvideo');
  $('.video--wrapper-cv').addClass('cv--video-visibility');
});
$('.cv--close-button').click(function() {
  $('.video--text--wrapper').removeClass('cv--showvideo');
  $('.video--wrapper-cv').removeClass('cv--video-visibility');
});
$('.cv--banner-btn span').click(function() {
  $('.cv--gallery-slideshow').addClass('cv--showgallery');
  $('.cv--gallery-banner-wrap').removeClass('cv--showbanner');
  $('#customslick-gallery').slick({
    infinite: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    asNavFor: null,
  });
});
$('.cv--close-gallery').click(function() {
  $('.cv--gallery-slideshow').removeClass('cv--showgallery');
  $('.cv--gallery-banner-wrap').addClass('cv--showbanner');
  $('#customslick-gallery').slick('unslick');
});
$('[data-scroll]').on('click', function(e) {
  e.preventDefault();
  var $section = $($(this).attr('href'));
  $('html, body').animate({
    scrollTop: $section.offset().top
  }, 500);
});
var prevScrollpos = window.pageYOffset;
$(window).scroll(function() {
  var scroll = $(window).scrollTop();
  if ($(".cv--expandableblock-wrapper").hasClass("expanded")) {
    var div_scroll = $('.cv--expandableblock-wrapper.expanded').offset().top;
    var div_height = $('.cv--expandableblock-wrapper.expanded').height();
    var bottom = div_scroll + div_height;
    if (scroll >= div_scroll) {
      $(".expanded .cv--expandableblock-header").addClass("cv--stickynav");
      if (scroll > bottom) {
        $(".expanded .cv--expandableblock-header").removeClass("cv--stickynav");
      }
    } else {
      $(".expanded .cv--expandableblock-header").removeClass("cv--stickynav");
    }
  }
  if ($(".cv--animationbanner").length > 0) {
    var animationcol = $('.cv--animationbanner').offset().top - 500;
    if (scroll >= animationcol) {
      $('.cv--animationbanner-wrap img:first').removeClass('animateImgFirst');
      $('.cv--animationbanner-wrap img:last').removeClass('animateImgLast');
      $('.cv--animationbanner-wrap h3').removeClass('animateH3');
    }
  }
  var main_scroll = 80;
  if (scroll >= main_scroll) {
    $('.site-header').addClass('fixed');
  } else {
    $('.site-header').removeClass('fixed');
  }
  if ($(".cv--show-buy-bar").length > 0) {
    var show_buy_bar = $('.cv--show-buy-bar').offset().top;
    var currentScrollPos = window.pageYOffset;
    if (scroll > show_buy_bar) {
      if (prevScrollpos > currentScrollPos) {
        $('.buy-bar').removeClass('active');
      } else {
        $('.buy-bar').addClass('active');
      }
      prevScrollpos = currentScrollPos;
    }
  }
});
$(document).ready(function() {
  var prevScrollpos = window.pageYOffset;
  window.onscroll = function() {
    var scroll = $(window).scrollTop();
    var currentScrollPos = window.pageYOffset;
    if (scroll > 50) {
      if (prevScrollpos > currentScrollPos) {
        $(".site-header").removeClass('fixed');
        $(".template-product .cv--stickyheader").removeClass('fixed');
        $(".template-product .site-header").removeClass('cv--fixed-header');
      } else {
        $(".site-header").addClass('fixed');
        $(".template-product .cv--stickyheader").addClass('fixed');
        $(".template-product .site-header").addClass('cv--fixed-header');
      }
      prevScrollpos = currentScrollPos;
    }
  }
})
$('[data-click]').on('click', function(e) {
  e.preventDefault();
  var $section = $($(this).attr('href'));
  $('.cv--specificationblock-navigation a').removeClass('activeTab');
  $('.cv--producttabs-header a').removeClass('activeTab');
  $(this).addClass('activeTab');
  $('.specification-tab-pane').removeClass('selectedtab');
  $('.product-tab-pane').removeClass('selectedtab');
  $section.addClass('selectedtab');
});
$('.cv--showspecs-btn').click(function() {
  $('.cv--specificationblock-wrapper').slideToggle();
  $(this).toggleClass("cv--toggled");
  $(this).children('p').toggleClass("cv--toggle");
  $('.cv--specificationblock-tab-content .specification-tab-pane').first().addClass('selectedtab');
  $('.cv--specificationblock-navigation a').first().addClass('activeTab');
});
$(document).ready(function() {
  if (($('.template-product').length > 0) && ($(window).width() <= 768)) {
    setTimeout(function() {
      $('.cv--bundle-one-details').addClass('hide');
    }, 200);
  }
  var html_content = '<span class="cv--verified-badge">Vérifié</span>';
  setTimeout(function() {
    $('.jdgm-carousel-item__reviewer-name').each(function() {
      $(this).append(html_content);
    });
  }, 500);
  $('#galleryslideshow').slick({
    infinite: true,
    dots: false,
    centerMode: true,
    centerPadding: '30%',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    focusOnSelect: false,
    responsive: [{
      breakpoint: 591,
      settings: {
        centerMode: true,
        centerPadding: '10%',
        arrows: false,
      }
    }]
  });
  var default_color = $('.cv--swatch-wrapper .single-option-selector__radio:checked').val();
  $('.thumbnails-index-li[ data-alt=' + default_color + ']').addClass('selectedThumb');
  $('.see-it-styled__slider').slick({
    infinite: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    asNavFor: null,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 551,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $('.choose-why__slider').slick({
    infinite: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    asNavFor: null,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 551,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $('.cv__testimonialSlideshow').slick({
    infinite: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 2,
    autoplay: false,
    arrows: true,
    asNavFor: null,
    focusOnSelect: true,
    centerMode: true,
    centerPadding: '16%',
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 551,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $('.cv__atriaFeatures-slideshow').slick({
    infinite: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    arrows: false,
    speed: 500,
    fade: true
  });
  $('.atria-vertical-slideshow1 .cv__atriaVerticalSlideshow-image').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.atria-vertical-slideshow1 .cv__atriaVerticalSlideshow-text',
    fade: true
  });
  $('.atria-vertical-slideshow1 .cv__atriaVerticalSlideshow-text').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.atria-vertical-slideshow1 .cv__atriaVerticalSlideshow-image',
    dots: false,
    arrows: false,
    vertical: true,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        dots: true,
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        dots: true
      }
    }]
  });
  $('.cv__dualImage-block-2 .cv__atriaVerticalSlideshow-image').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.cv__dualImage-block-2 .cv__atriaVerticalSlideshow-text',
    fade: true
  });
  $('.cv__dualImage-block-2 .cv__atriaVerticalSlideshow-text').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.cv__dualImage-block-2 .cv__atriaVerticalSlideshow-image',
    dots: false,
    arrows: false,
    vertical: true,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        dots: true,
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        dots: true,
      }
    }]
  });
  $('.atria-vertical-slideshow .cv__atriaVerticalSlideshow-image').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.atria-vertical-slideshow .cv__atriaVerticalSlideshow-text',
    fade: true
  });
  $('.atria-vertical-slideshow .cv__atriaVerticalSlideshow-text').slick({
    infinite: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    asNavFor: '.atria-vertical-slideshow .cv__atriaVerticalSlideshow-image',
    dots: false,
    arrows: false,
    vertical: true,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        dots: true,
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        dots: true,
      }
    }]
  });
  $('.cv__atriaWatchSlideshow').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.cv__atriaWatch_section',
    fade: true,
    responsive: [{
      breakpoint: 769,
      settings: {
        arrows: false,
      }
    }]
  });
  $('.cv__atriaWatch_section').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.cv__atriaWatchSlideshow',
    dots: false,
    arrows: false,
    vertical: true,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        dots: true,
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        dots: true,
      }
    }]
  });
  $('.cv--producttabs-content .product-tab-pane').first().addClass('selectedtab');
  $('.cv--producttabs-header a').first().addClass('activeTab');
  var acc = document.getElementsByClassName("accordionProduct-wrap");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
  judgemeOpts = window.judgemeOpts || {};
  judgemeOpts.carouselNoAutoSlide = true;
  if ($(window).width() <= 768) {
    $('.cv--about-section-6').slick({
      infinite: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      centerMode: true,
      centerPadding: '15%'
    });
    $('.cv--about-section-8').slick({
      infinite: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      centerMode: true,
      centerPadding: '15%'
    });
    $('.cv--animateblock-slide').slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      centerMode: true,
      centerPadding: '25%'
    });
    $('.cv--1551684202872').slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      centerMode: true,
      centerPadding: '25%'
    });
    $('.cv--1551696569045').slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
    });
    $('.cv--1567498394033').slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      centerMode: true,
      centerPadding: '28%'
    });
    $('.cv--atria-columns').slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      centerMode: true,
      centerPadding: '25%'
    });
    $('.cv--cv_dara_columns').slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      centerMode: true,
      centerPadding: '25%'
    });
    $('.cv--cv--columns').slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      centerMode: true,
      centerPadding: '25%'
    });
  }
  setTimeout(function() {
    $('.atria-vertical-slideshow1 .cv__atriaVerticalSlideshow-text .slick-slide.slick-active:first').trigger('click');
    $('.cv__dualImage-block-2 .cv__atriaVerticalSlideshow-text .slick-slide.slick-active:first').trigger('click');
    $('.atria-vertical-slideshow .cv__atriaVerticalSlideshow-text .slick-slide.slick-active:first').trigger('click');
  }, 500);
});
$('.cv--swatch-wrapper .single-option-selector__radio').click(function() {
  var color = $(this).val();
  $('li.selectedThumb').removeClass('selectedThumb');
  $('.thumbnails-index-li[ data-alt=' + color + ']').addClass('selectedThumb');
  setTimeout(function() {
    if (color == 'white') {
      $('.selectedThumb:first-child img').trigger('click');
    } else {
      $('.selectedThumb:nth-child(4) img').trigger('click');
    }
  }, 500);
})
$(".thumbnails-index-li img").on('click', function() {
  setTimeout(function() {
    $(".cv--designblock-featured-image div img").attr("src", $(this).attr("src"));
  }, 500);
  $('.thumbnails-index-li > div').removeClass('activeThumb');
  $(this).parents('a').parent().addClass('activeThumb');
});
$(function() {
  function multi_item__cart() {
    var checkValues = $('input[name=bundle_selc]:checked').map(function() {
      return $(this).attr('data-variant-id');
    }).get();
    $.each(checkValues, function(index, value) {
      console.log(index + ": " + value);
      $.ajax({
        type: "post",
        url: '/cart/add.js',
        data: {
          id: value,
          quantity: 1
        },
        async: false
      })
    });
    setTimeout(function() {
      $('.cart-link.js-drawer-open-button-right').trigger('click');
    }, 1000);
  }

  function single_item__cart(value) {
    $.ajax({
      type: "post",
      url: '/cart/add.js',
      data: {
        id: value,
        quantity: 1
      },
      success: function() {
        console.log('ATC Success.');
        window.location.href="/checkout";
      }
    })
//     setTimeout(function() {
//       $('.cart-link.js-drawer-open-button-right').trigger('click');
//     }, 1000);
  }
  $('#AddToCart--buybar').click(function(e) {
    e.preventDefault();
    var value = $(this).data('variant-id');
    single_item__cart(value);
  });
  $('#AddToCart--multi-product').click(function(e) {
    e.preventDefault();
    multi_item__cart();
  });
  $('.product-single__add-to-cart button').click(function(e) {
    e.preventDefault();
    var value = $(this).data('variant-id');
    single_item__cart(value);
  });
  $('#ATC--multi-checkout').click(function(e) {
    e.preventDefault();
    multi_item__cart();
    setTimeout(function() {
      window.location.href = "/checkout";
    }, 1500);
  });
  $('#ATC--single-checkout').click(function(e) {
    var checkValues = 13603704864841;
    $.ajax({
      type: "post",
      url: '/cart/add.js',
      data: {
        id: checkValues,
        quantity: 1
      }
    })
    setTimeout(function() {
      window.location.href = "/checkout";
    }, 1500);
  });
});
$('.see-it-styled-thumb').on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({
    scrollTop: $('.see-it-styled-wrapper').offset().top
  }, 500);
});
$("input[name=bundle_selc]").change(function() {
  var numberOfChecked = $('input[name=bundle_selc]:checked').length;
  if (numberOfChecked == 3) {
    $('#AddToCart--multi-product .btn__text').html('Add 3 items to cart');
  } else {
    $('#AddToCart--multi-product .btn__text').html('Add 2 items to cart');
  }
});
$("input[name=bundle]:radio").click(function(ev) {
  if (ev.currentTarget.value == "single") {
    $('#AddToCart--multi-product').addClass('hide');
    $('.product-single__add-to-cart').removeClass('hide');
    $('.cv--bundle-two-details').removeClass('hide');
    $('.cv--bundle-one-details').addClass('hide');
  } else if (ev.currentTarget.value == "multi") {
    $('.cv--bundle-one-details').removeClass('hide');
    $('.cv--bundle-two-details').addClass('hide');
    $('#AddToCart--multi-product').removeClass('hide');
    $('.product-single__add-to-cart').addClass('hide');
  }
});
$('.product-single__photo-wrapper').click(function() {
  if ($(this).hasClass('cv--product-thumbnails')) {
    $('.product-single__photo--flex-wrapper.custom-main-image .product-single__photo--container').addClass('hide');
  } else {
    $('.product-single__photo--flex-wrapper.custom-main-image .product-single__photo--container').removeClass('hide');
  }
});
$('.cv--read-reviews *').on('click', function() {
  var $section = $('#scrollReviews');
  $('html, body').animate({
    scrollTop: $section.offset().top - 60
  }, 500);
});
$('.drawer__cart').on('change', 'input[name=checkout]', function() {
  var checkout_type = $(this).val();
  if (checkout_type == 'account') {
    $('.drawer .btn--secondary.cart__checkout').css('display', 'none');
    $('.drawer .checkout-btn-row--cv').css('display', 'block');
  } else {
    $('.drawer .btn--secondary.cart__checkout').css('display', 'block');
    $('.drawer .checkout-btn-row--cv').css('display', 'none');
  }
});
$(document).ready(function() {
  function custom_menu() {
    var $siteNav = $('.site-nav');
    var $siteNavOpen = $('.site-nav--open');
    if ($(window).width() > 991) {
      $siteNav.removeClass('site-nav--compress');
      $siteNavOpen.removeClass('site-nav--open__display');
      $siteNavOpen.parent().addClass('large--hide');
    } else {
      $siteNav.addClass('site-nav--compress');
      $siteNavOpen.addClass('site-nav--open__display');
      $siteNavOpen.parent().removeClass('large--hide');
    }
  }
  custom_menu();
  $(window).resize(function() {
    custom_menu();
  });
})
$(".cv--bundle-block-wrap input[name=bundle]:radio").click(function(ev) {
  if (ev.currentTarget.value == "single") {
    $('.cv--reason-details.single').addClass('active');
    $('.cv--reason-details.multi').removeClass('active');
  } else {
    $('.cv--reason-details.multi').addClass('active');
    $('.cv--reason-details.single').removeClass('active');
  }
});
$('#reasons .cv--site-footer__linklist li').click(function(e) {
  e.preventDefault();
  var handle = $(this).attr('data-handle');
  $('.cv--footer-pop-up .reason-content-wrap').each(function() {
    var content_id = $(this).attr('data-id');
    if (content_id == handle) {
      $(this).addClass('active');
    } else {
      $(this).removeClass('active');
    }
  });
  $('.cv--footer-pop-up').addClass('showpop-up');
});
$('.cv--reason-close').click(function() {
  $('.cv--footer-pop-up').removeClass('showpop-up');
  $('.cv--footer-pop-up .reason-content-wrap').removeClass('active');
});
$('.cv__country_switch').hover(function() {
  $(this).addClass('showList');
}, function() {
  $(this).removeClass('showList');
});
$(document).ready(function() {
  $(".cv__saleColumn-block").slick({
    infinite: !0,
    autoplay: !0,
    autoplaySpeed: 3e3,
    dots: !1,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: !1,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  }), $(".custom-reviews__slider").slick({
    infinite: !0,
    autoplay: !0,
    autoplaySpeed: 1e4,
    dots: !1,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !1
  });
  var a = window.pageYOffset;
  $(window).scroll(function() {
    var t = $(window).scrollTop(),
        c = window.pageYOffset;
    $("#shopify-section-sale-columns").offset().top;
    t > 50 && (a > c ? $(".cv__saleColumns-section").removeClass("sticky") : $(".cv__saleColumns-section").addClass("sticky"), a = c)
  })
}), $("input[name=bf-bundle]:radio").click(function(a) {
  var t = $(this).val(),
      c = $(this).attr("data-price"),
      i = $(this).attr("data-pprice"),
      e = $(this).attr("data-warranty");
  $(".cv__blackFriday-atc").attr("data-variant-id", t), $("#AddToCart--buybar").attr("data-variant-id", t), $(".cv__blackFriday-atc").attr("data-price", c), $(".cv__blackFriday-atc").attr("data-pprice", i), $('[name="pin-price"]').val(i).change(), $(".cv__blackFriday-modal-warranty-atc").attr("data-warranty", e), $(".cv__blackFriday-modal-price").each(function() {
    $(this).data("id") == t ? $(this).removeClass("hide") : $(this).addClass("hide")
  }), $(this).parents(".cv__blackFriday-bundle-block").siblings().removeClass("active"), $(this).parents(".cv__blackFriday-bundle-block").addClass("active")
}), $(".cv__blackFriday-modal-atc, .cv__blackFriday-modal-close").click(function(a) {
  a.preventDefault(), $(".cv__blackFriday-modal").addClass("hide"), $("body").removeClass("cv__bf-overlay"), $(".cart-link.js-drawer-open-button-right").trigger("click")
}), $(".cv__blackFriday-atc").click(function(a) {
  a.preventDefault();
  var $this = $(this);
  //var t = $(this).attr("data-variant-id");
  var t = $(this).parents('.product-single__meta--wrapper').find('#ProductSelect').val();
  $(".cv__blackFriday-atc").attr("data-price");
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: t,
      quantity: 1
    },
    success: function(a) {
      if($('.cv__blackFriday-bundle-tabs').length > 0){
        var has_pack = $('.cv__blackFriday-bundle-block.active').data('pack');
        if(has_pack == true){
          var var_id = $('.cv__blackFriday-bundle-block.active').find('.packSelect').val();
          addPack(var_id);      
        }
        else{
           //window.location.href="/checkout";
          $(".cart-link.js-drawer-open-button-right").trigger("click");
        }
      }
      else{
         //window.location.href="/checkout";
        $(".cart-link.js-drawer-open-button-right").trigger("click");
      }
    }
  }); 
}), $(".scrollToBundle").on("click", function(a) {
  a.preventDefault();
  var t = $(".cv__blackFriday-bundle");
  $("html, body").animate({
    scrollTop: t.offset().top - 100
  }, 1e3)
});
$('#CartDrawer').on('click', '.ajax-open__modal', function(e) {
  e.preventDefault();
  $('.afterpay__modal-container').addClass('active');
});
$('body').on('click', '.afterpay__modal-container', function() {
  $('.afterpay__modal-container').removeClass('active');
});

$(document).ready(function(){
  $('.template-index .cv--product-thumbnails a').click(function(e){
    e.preventDefault();
    var imageid = $(this).data('image-id');
    $(this).parents('.product-single__photos').find('.product-single__photo--container').addClass('hide');
    $(this).parents('.product-single__photos').find('#ProductImageWrapper-' + imageid).removeClass('hide');

  });
  
  $('.swatch input[type="radio"]').change(function(e){
    e.preventDefault();
    var imageid = $(this).data('image-id');
    if(imageid){
      $('.product-single__photos').find('.product-single__photo--container').addClass('hide');
      $('.product-single__photos').find('#ProductImageWrapper-' + imageid).removeClass('hide');
    }
  });

  $('.home_product_images').slick({
    arrows: false,
    dots: true,
    adaptiveHeight: true
  });
});


function addPack(v_id){
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: v_id,
      quantity: 1
    },
    success: function(a) {
      //window.location.href="/checkout";
      $(".cart-link.js-drawer-open-button-right").trigger("click");
    }
  });
}

function proImageSwitcher(img_id){

}

